module.exports = __webpack_public_path__ + "static/media/steam_logo.bf27ecd6.svg";